import { Box, FormControl, IconButton, InputLabel, LinearProgress, MenuItem, Modal, Select, Tab, Tabs, TextField, Typography } from '@mui/material';
import './styles.scss'
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { DynSort } from './sort_dyn';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { updateFieldVariablesValues } from 'src/shared/util/updateDataServer';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { loadLocationDetails } from 'src/stateManagement/redux/slices/location/asyncReducers';
import { useParams } from 'react-router-dom';
import { CustomTabPanel } from 'src/tecnica/pages/dashboard/reports/close_daily';

export const ModalAnalyst = ({ open, onClose, sortDyns, activeDyn }: { open: any, onClose: any, sortDyns: any, activeDyn: any, listSortDyns: DynSort[] }) => {

    const { locationSetPoints } = useSelector((state) => state.location);

    const [loading, setloading] = useState(false)

    const dispatch = useDispatch();

    const [value, setValue] = useState(0);

    const { id } = useParams();

    const [variablesToUpdate, setVariablesToUpdate] = useState<any>(undefined)

    const [setPointsToUse, setSetPointsToUse] = useState<any>(undefined)

    useEffect(() => {
        const beamApiModel = locationSetPoints?.find((x: any) => x.id === "d72cbe1b-1fe1-11f0-a71e-00505652cca1");
        const beamMaxLoad = locationSetPoints?.find((x: any) => x.id === "94996b01-1241-11f0-bbc3-00505652cca1");
        setSetPointsToUse({
            beamApiModel: beamApiModel?.value,
            beamMaxLoad: beamMaxLoad?.value,
        })

        if (!activeDyn?.structuralMaxLoad) {
            let structuralMaxLoad = 0
            if (beamApiModel) {
                let beamMaxLoadAPI = beamApiModel?.value?.split("-")[1]
                if (beamMaxLoadAPI) {
                    structuralMaxLoad = parseFloat(beamMaxLoadAPI) * 100 / 1000
                }
            }

            if (beamMaxLoad?.value && !isNaN(parseFloat(beamMaxLoad.value))) {
                structuralMaxLoad = parseFloat(beamMaxLoad.value)
            }

            if (structuralMaxLoad>0){
                onChangeVariables(structuralMaxLoad, "structuralMaxLoad")
            }
        }else{
            const newVariablesToUpdate: any = { ...variablesToUpdate }
            delete newVariablesToUpdate.structuralMaxLoad
            setVariablesToUpdate(newVariablesToUpdate)
        }

    }, [locationSetPoints, activeDyn])


    const onSaveDiagnostic = () => {
        setloading(true)
        updateFieldVariablesValues({
            ...variablesToUpdate,
            originFieldActivityIds: [sortDyns?.fieldActivityId],
        }).then((data) => {
            setloading(false)
            Swal.fire({
                title: "Guardado!",
                icon: "success",
            });
            dispatch(loadLocationDetails(id!));
            setVariablesToUpdate(undefined)
        }
        ).catch((error) => {
            Swal.fire({
                title: "Error!",
                icon: "error",
            });
            setloading(false)
        })
    }

    const onChangeVariables = (value: any, label: any) => {
        const newVariablesToUpdate: any = { ...variablesToUpdate }
        newVariablesToUpdate[label] = value

        if (label === "structuralMaxLoad") {
            const currentPercentageMaxLoad = (activeDyn?.surfacePeakLoad || 0) / value * 100
            newVariablesToUpdate.currentPercentageMaxLoad = currentPercentageMaxLoad
        }

        setVariablesToUpdate(newVariablesToUpdate)
    }

    const handleClose = () => {
        if (loading) return
        if (variablesToUpdate !== undefined) {
            Swal.fire({
                title: "Hay cambios no guardados, ¿Desea cerrar?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Si",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.isConfirmed) {
                    onClose();
                }
            });
        } else {
            onClose();
        }
    }

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };


    return (
        <Modal
            open={open}
            onClose={() => handleClose()}
        >
            <Box className="modal_update_card_location">
                {/* headers */}
                <Box className="modal_header" 
                    sx={{ 
                        position: "sticky", top: 0, 
                        zIndex: 10, display: "flex", 
                        justifyContent: "space-between", alignItems: "center", 
                        padding: "15px" }}>
                    <IconButton
                        aria-label="delete"
                        size='small'
                        onClick={() => handleClose()}
                    >
                        <CloseIcon color="error" />
                    </IconButton>
                    <Typography className='title' id="modal-modal-title" variant="h6" component="h2">
                        Analisis de carta
                    </Typography>
                    <IconButton
                        aria-label="delete"
                        size='small'
                        onClick={() => onSaveDiagnostic()}
                    >
                        <SaveOutlinedIcon color="primary" />
                    </IconButton>
                </Box>
                {loading && (
                    <>
                        <Box className="modal_analyst_loading_background" />
                        <Box className="modal__analyst_task_loading">
                            <LinearProgress />
                            Saving....
                        </Box>
                    </>
                )}
                {/* body */}
                <Box sx={{ p: 2, gap: 2 }} >
                    {/* Tabs */}
                    <Box
                        sx={{
                            borderBottom: 1,
                            borderColor: "divider",
                        }}
                    >
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            scrollButtons="auto"
                            variant="scrollable"
                        >
                            <Tab
                                label="Cargas Estructural"
                            />
                        </Tabs>
                    </Box>
                    {/* Cargas Estructural */}
                    <CustomTabPanel value={value} index={0}>
                        <Grid className="modal_body" sx={{ gap: 2 }}>
                            {/* No change */}
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Surface Peak Load"
                                    value={typeof activeDyn?.surfacePeakLoad === 'number' ? activeDyn.surfacePeakLoad.toFixed(2) : 0}
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Surface Min Load"
                                    value={typeof activeDyn?.surfaceMinLoad === 'number' ? activeDyn.surfaceMinLoad.toFixed(2) : 0}
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Delta Surface Load"
                                    value={typeof activeDyn?.deltaSurfaceLoad === 'number' ? activeDyn.deltaSurfaceLoad.toFixed(2) : 0}
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Bottom Peak Load"
                                    value={typeof activeDyn?.bottomPeakLoad === 'number' ? activeDyn.bottomPeakLoad.toFixed(2) : 0}
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Bottom Min Load"
                                    value={typeof activeDyn?.bottomMinLoad === 'number' ? activeDyn.bottomMinLoad.toFixed(2) : 0}
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Delta Bottom Load"
                                    value={typeof activeDyn?.deltaBottomLoad === 'number' ? activeDyn.deltaBottomLoad.toFixed(2) : 0}
                                    fullWidth
                                />

                            </Grid>
                            {/* Changes */}
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Marca Unidad Superficie"
                                    onChange={(e) => onChangeVariables(e.target.value, "surfaceUnitBrand")}
                                    value={variablesToUpdate?.surfaceUnitBrand || activeDyn?.surfaceUnitBrand}
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Modelo Unidad Superficie"
                                    onChange={(e) => onChangeVariables(e.target.value, "surfaceUnitModel")}
                                    value={variablesToUpdate?.surfaceUnitModel || activeDyn?.surfaceUnitModel}
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Max Carga Estructural"
                                    onChange={(e) => {
                                        const value = parseFloat(e.target.value.replace(/[^0-9.]/g, '')) || 0;
                                        if (value >= 0) {
                                            onChangeVariables(value, "structuralMaxLoad");
                                        }
                                    }}
                                    value={variablesToUpdate?.structuralMaxLoad || activeDyn?.structuralMaxLoad || 0}
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="% Carga Estructural"
                                    value={
                                        typeof variablesToUpdate?.currentPercentageMaxLoad === 'number' ? variablesToUpdate.currentPercentageMaxLoad.toFixed(2) : 0
                                            || typeof activeDyn?.currentPercentageMaxLoad === 'number' ? activeDyn.currentPercentageMaxLoad.toFixed(2) : 0}
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Modelo API Pozo"
                                    disabled
                                    value={setPointsToUse?.beamApiModel}
                                    fullWidth
                                />
                            </Grid>
                            <Grid>
                                <TextField
                                    id="variable"
                                    size="small"
                                    label="Max Carga Estructural"
                                    disabled
                                    value={setPointsToUse?.beamMaxLoad || 0}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </CustomTabPanel>
                </Box>
            </Box>
        </Modal>
    )
}